import type { ID } from '@octopus-do/octopus-project-core'
import { artBoardActions } from '@store/reducers/artboard'
import { useCallback } from 'react'
import { useDispatch } from 'react-redux'

import { GtmTriggerName, sendGtmEvent } from '@/constants/gtm'

// The jump itself (expand ancestors, centre the canvas, select the page) is a
// saga — see store/reducers/artboard/saga/jumpToPage.
export const useJumpToPage = () => {
  const dispatch = useDispatch()

  return useCallback(
    (id: ID) => {
      sendGtmEvent(
        GtmTriggerName.STRUCTURE_PAGE_CLICK,
        'Page clicked in the structure sidebar'
      )

      dispatch(artBoardActions.jumpToPage({ id }))
    },
    [dispatch]
  )
}
